import { ShieldAlert } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';
import { Card, CardContent } from '../ui/card';

/**
 * Shared route guard (26 Oct 2026, Performance/PMS admin-only round): blocks a page at
 * the route level, before it ever mounts or calls its API, so a user without the
 * required module permission sees a clear "you don't have access" message instead of
 * an empty page or a wall of failed-request error toasts. Reusable for the 2C round's
 * other Admin-only pages — just pass a different moduleId/action/pageName.
 */
export function ModuleAccessGate({ moduleId, action = 'VIEW', pageName, children }) {
  const { canAccess } = useAuth();

  if (!canAccess(moduleId, action)) {
    return (
      <div className="space-y-6" data-testid={`${moduleId.toLowerCase()}-page-access-denied`}>
        <Card className="rounded-sm">
          <CardContent className="p-12 text-center" data-testid="module-access-denied">
            <ShieldAlert className="h-12 w-12 mx-auto text-muted-foreground/50 mb-3" />
            <p className="font-medium">You don't have access to this page</p>
            <p className="text-muted-foreground text-sm mt-1">
              {pageName ? `${pageName} access is currently restricted to Admins.` : 'This page is currently restricted.'}
            </p>
          </CardContent>
        </Card>
      </div>
    );
  }

  return children;
}
